// components/plScenario/table/TableHeader.jsx
import React from 'react';

const TableHeader = ({ viewMode, months, quarters, selectedYear }) => {
  return (
    <thead className="sticky top-0 z-10 bg-brightblue-500">
      <tr>
        <th className="px-8 py-3 text-left text-xs font-bold text-white border-b-2 border-gray-300 w-64">
          Account
        </th>
        {viewMode === 'monthly' ? (
          months.map((month) => (
            <th
              key={month.month_num}
              className="px-2 py-3 text-center text-xs font-bold border-b-2 border-gray-300 min-w-[100px] text-white"
            >
              <div>{month.month_abbr}</div>
              <div className="text-[10px] font-normal">
                {month.is_actual ? 'Actual' : 'Budget'}
              </div>
            </th>
          ))
        ) : (
          quarters.map((quarter) => (
            <th
              key={quarter.quarter}
              className="px-2 py-3 text-center text-xs font-bold border-b-2 border-gray-300 min-w-[120px] text-white"
            >
              <div>{quarter.quarter} {selectedYear}</div>
              <div className="text-[10px] font-normal">
                {quarter.is_actual ? 'Actual' : quarter.is_partial ? 'Partial' : 'Budget'}
              </div>
            </th>
          ))
        )}
        <th className="px-4 py-3 text-center text-xs font-bold text-white border-b-2 border-gray-300 min-w-[120px]">
          Total
        </th>
      </tr>
    </thead>
  );
};

export default TableHeader;